import { Component } from '@angular/core';
import { HttpMemberService } from '../../../service/http-member.service';
import { MemberDto } from '../../../service/dto';
import { Router } from '@angular/router';

@Component({
  selector: 'app-member-list',
  standalone: false,
  templateUrl: './member-list.component.html',
  styleUrl: './member-list.component.scss'
})
export class MemberListComponent {
	data: MemberDto[] = [];
	constructor(private httpService: HttpMemberService, private router: Router){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

	doView(input: MemberDto){
		this.router.navigate(['/member',input.id,'view']);
	}
}
